import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi' || 'md',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#473729', // brown
        secondary: '#A0D1CA',
        tertiary1: '#FFBF3F',
        tertiary2: '#D1CCBD',
        tertiary3: '#E87722', // orange
        darkPink: '#EA526F',
        alabaster: '#f7f6ef',
        mischka: '#a7a9ac',
        grape: '#414042',
        tawny: '#C95100',
        tenne: '#CA6B00',
        nero: '#292929',
        sandybrown: '#EE9F64',
        error: '#DE2B41',
        snow: '#FAFAFA',
        nobel: '#979797',
        whisper: '#E8E8E8',
        WhisperSecondary: '#E5E5E5',
        dimGray: '#646464',
        blanchedAlmond: '#FFEBC7',
        darkOrange: '#FF8E10',
        gainsboro: '#D8D8D8',
        white: '#FFFFFF',
        green: '#257E0F',
        persianred: '#C02E2E',
        pattensBlue: '#CCE7FD',
        suvaGrey: '#919191',
        foam: '#CDEAE6',
        sinbad: '#A0D1CA',
        silver: '#C6C6C6',
        whiteSmok: '#f0f0f0',
        whiteSmokTwo: '#f6f6f6',
        cornflowerBlue: '#4E83F0',
        zambezi: '#5d5d5d',
        forestGreen: '#028E2D',
        alizarin: '#DE2B41',
      },
    },
  },
});
